export default __webpack_public_path__ + "static/media/mediumDesk.91f924a2.svg";